import { useMemo } from 'react';

import { Box, Checkbox } from '@mui/material';
import { VideocamOutlined } from '@mui/icons-material';
import { useCurrentuser, useCurrentuserRefetch } from '@uplift/contexts';
import { trackStartSessionClick, useL10n, useVideoContext } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { Button, MobileSection, StickyMobileFooter } from '@uplift/ui-v2';

import { ConnectionTips } from '../../../modals/connection-tips';
import { InfoComponentProps } from './info.component';

export const MobileInfoComponent: React.FC<InfoComponentProps> = ({
  onSubmit,
  startButtonDisabled,
  blurAvailable,
}) => {
  const l10n = useL10n();
  const { isVideoFilterEnabled, toggleVideoFilter, isVideoFilterSupported } = useVideoContext();
  const displayBlurToggle = blurAvailable && isVideoFilterSupported;
  const me = useCurrentuser();
  const { refetchUser } = useCurrentuserRefetch();

  const currentUser = useMemo(() => {
    if (!me) {
      refetchUser();
    }
    return me;
  }, [ me, refetchUser ]);

  const handleOnSubmit = (session: any) => {
    trackStartSessionClick({
      userType: UserRole[currentUser?.role]
    });
    onSubmit(session);
  };

  return (
    <>
      <Box p={2}>
        <ConnectionTips />
      </Box>
      {displayBlurToggle && (
        <MobileSection
          divider
          bottomDivider
          label={l10n.sessions.backgroundBlur}
          header="Video Effects"
        >
          <Checkbox
            checked={isVideoFilterEnabled}
            onChange={_e => toggleVideoFilter()}
            value="outlined"
            color="secondary"
          />
        </MobileSection>
      )}
      <StickyMobileFooter>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<VideocamOutlined />}
          disabled={startButtonDisabled}
          onClick={handleOnSubmit}
        >
          {l10n.sessions.joinSession}
        </Button>
      </StickyMobileFooter>
    </>
  );
};
